var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSteth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "steth",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00A3FF",
    d: "M103.4,224.1l-4,6.1c-45,69-34.9,159.4,24.2,217.3c34.8,34.1,80.3,51.1,125.9,51.1 C249.5,498.6,249.5,498.6,103.4,224.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fill: "#00A3FF",
    d: "M249.5,307.5l-146.1-83.4c146.1,274.5,146.1,274.5,146.1,274.5C249.5,438.8,249.5,370.3,249.5,307.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fill: "#00A3FF",
    d: "M395.7,224.1l4,6.1c45,69,34.9,159.4-24.2,217.3c-34.8,34.1-80.3,51.1-125.9,51.1 C249.6,498.6,249.6,498.6,395.7,224.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fill: "#00A3FF",
    d: "M249.6,307.5l146.1-83.4C249.6,498.6,249.6,498.6,249.6,498.6C249.6,438.8,249.6,370.3,249.6,307.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fill: "#00A3FF",
    d: "M249.6,121.1V265l125.8-71.9L249.6,121.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fill: "#00A3FF",
    d: "M249.6,121.1l-125.9,72L249.6,265V121.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#00A3FF",
    d: "M249.6,0.1l-125.9,193l125.9-72.2V0.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fill: "#00A3FF",
    d: "M249.6,120.9l125.9,72.2L249.6,0V120.9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteth);
export default __webpack_public_path__ + "static/media/steth.3866b8edbc3a6cf7a64a2bd3de5193a7.svg";
export { ForwardRef as ReactComponent };